import { render, staticRenderFns } from "./ImsInventoryCompletedList.vue?vue&type=template&id=00567bb5&"
import script from "./ImsInventoryCompletedList.vue?vue&type=script&lang=js&"
export * from "./ImsInventoryCompletedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports